import React from "react";
import { Field, useFormikContext } from "formik";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { TextField } from "formik-mui";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function AdvancedSettings() {
  const { values, setFieldValue } = useFormikContext();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      minHeight="100vh"
      padding={2}
      paddingTop={14}
    >
      <Box width="100%" maxWidth={900}>
        <Typography
          variant="h5"
          gutterBottom
          textAlign="center"
          color="primary"
        >
          Advanced Settings
        </Typography>

        <Typography
          variant="subtitle2"
          color="textSecondary"
          align="center"
          gutterBottom
        >
          Please tell us more about your project
        </Typography>

        <Grid container spacing={3}>
          {[
            { name: "notes", label: "Project notes" },
            { name: "objective", label: "Objective" },
            { name: "brief", label: "Brief" },
            { name: "methodology", label: "Methodology" },
            { name: "study_duration", label: "Study duration" },
            { name: "decision_to_inform", label: "Decision to inform" },
            { name: "incentive", label: "Incentive" },
          ].map((field) => (
            <Grid item xs={12} key={field.name}>
              <Field
                name={field.name}
                component={TextField}
                label={field.label}
                multiline
                fullWidth
                variant="filled"
              />
            </Grid>
          ))}

          {[
            {
              name: "proposal_signoff_date",
              label: "Proposal sign-off date",
              value: values.proposal_signoff_date,
            },
            {
              name: "proposed_data_collection_start",
              label: "Proposed data collection start",
              value: values.proposed_data_collection_start,
            },
            {
              name: "proposed_data_collection_end",
              label: "Proposed data collection end",
              value: values.proposed_data_collection_end,
            },
            {
              name: "debrief_date",
              label: "Debrief date",
              value: values.debrief_date,
            },
          ].map(({ name, label, value }) => (
            <Grid item xs={12} key={name}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label={label}
                  value={value ? new Date(value) : null}
                  onChange={(time) => {
                    if (typeof time === "object") {
                      setFieldValue(
                        name,
                        time.format("YYYY-MM-DD HH:mm:ss")
                      );
                    }
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      variant: "filled",
                      name,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
